// Splits a ranked list into a standalone prefix and a folded tail so a long tail
// of small entries can roll up into a single "Other". Rows at or above
// `minShare` of the total stay standalone (bounded to [1, maxKept]); the rest
// fold. A lone would-be-folded row stays standalone rather than becoming an
// "Other" of one, and the largest row is always kept so nothing folds everything.
// Assumes `rows` is already sorted descending by `value`.
export function splitBySharePrefix<T>(
  rows: readonly T[],
  value: (row: T) => number,
  total: number,
  { minShare, maxKept }: { minShare: number; maxKept: number }
): { kept: readonly T[]; folded: readonly T[] } {
  const bigEnough = rows.filter(
    (row) => total > 0 && value(row) / total >= minShare
  ).length;
  let keep = Math.min(Math.max(bigEnough, 1), maxKept);
  if (rows.length - keep === 1) keep = rows.length;
  return { kept: rows.slice(0, keep), folded: rows.slice(keep) };
}
